module.exports = __webpack_public_path__ + "img/flag-africa.2f36417.svg";